import { render, staticRenderFns } from "./CampaignsStats.vue?vue&type=template&id=47c488cd"
import script from "./CampaignsStats.vue?vue&type=script&lang=js"
export * from "./CampaignsStats.vue?vue&type=script&lang=js"
import style0 from "./CampaignsStats.vue?vue&type=style&index=0&id=47c488cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports